import React from "react";
import { Box, Stepper, Step, StepLabel } from "@vapor/react-material";
import { Trans } from "@onefront/react-sdk";
import { BusinessSteps } from "../../../../@types/enums/business/BusinessSteps";

export const BusinessStepper = ({ stepActive }) => {
    const businessSteps = Object.values(BusinessSteps);
    const stepIndex = businessSteps.findIndex(step => step === stepActive);

    return (
        <Box sx={{ width: "600px" }}>
            <Stepper activeStep={stepIndex} alternativeLabel>
                {businessSteps.map(step => {
                    if (step) {
                        return (
                            <Step key={`step.business.${step}`}>
                                <StepLabel>
                                    <Trans i18nKey={`step.business.${step}`} ns="CM" components={{ br: <br /> }} />
                                </StepLabel>
                            </Step>
                        );
                    }
                    return null;
                })}
            </Stepper>
        </Box>
    );
};
